import './form.styl';

import tpl_form from './form.jst';
import tpl_table from './table.jst';
import template from './index.jst';

import _ from 'lodash';

import { ErrorsModal } from '../../../../utils';

import { View } from "backbone.marionette";
import { Model } from 'backbone';

const style =  {
	style: {
		base: {
			color: '#042d25',
			fontFamily: 'RLFont, "Helvetica Neue", Helvetica, sans-serif',
			fontSize: '12px',
			width: '100%',
			lineHeight: '36px',
			background: '#fff',
			'::placeholder': {
				color: '#042d25',
			},
		},
		invalid: {
			color: '#D61122',
		}
	}
};

export default class CoachFormTableView extends View {
	template() {
		return template;
	}

	get tagName() {
		return 'form';
	}

	get attributes() {
		return {
			novalidate: true,
		}
	}

	get className() {
		return 'base-form assistant-coach-form';
	}

	ui() {
		return {
			submit: '.js-submit',
			code_submit: '.js-code-submit',
			cancel_subscription: '.js-cancel-subscription',
			card_part: '.js-card-part',
			card_number: '.js-card-number',
			card_expiry: '.js-card-expiry',
			card_cvv: '.js-card-cvv',
			payment_field: '.js-payment-field',
		}
	}

	triggers() {
		return {
			'click @ui.cancel_subscription': 'form:cancel:subscription:submit'
		}
	}

	events() {
		return {
			'input': 'onUpdate',
			'change': 'onUpdate',
			'click @ui.submit': 'onSubmit',
			'keyup @ui.card_part': 'onCardKeyUp',
			'click @ui.code_submit': 'codeOnSubmit'
		}
	}

	initialize() {
		this.model = new Model({
			current_year: (new Date()).getFullYear()
		});

		this.listenTo(this, 'dom:refresh', this.renderForm)
	}

	init(args) {
		const {
			has_assistant_coach,
			assistant_coach_plan,
			transactions,
			is_plan_payed,
			has_active_month_subscription
		} = args;

		this.model.set({
			transactions,
			assistant_coach_plan,
			has_active_month_subscription
		}, { silent: true });

		this.listenTo(this.model, 'change', this.render);

		if (has_assistant_coach && is_plan_payed) {
			this.switchToTable()
		}
		else {
			this.switchToForm();
		}

		this.model.trigger('change');
	}

	get card() {
		const
			cardModel = this.model.toJSON(),
			{ card_number, card_expiry, card_cvv, name } = cardModel;

		return {
			card_number, card_expiry, card_cvv, name
		};
	}

	onUpdate({ target }) {
		const
			{ name, value, checked, type } = target,
			model = this.model.toJSON(),
			val = type === 'checkbox' ? checked : value;

		if (!target.checkValidity()) {
			target.value = _.result(model, name);

			return this;
		}

		if (name === 'code_coach') {
			if (val !== '') {
				_.set(model, 'locked_elements', true);
				this.getUI('payment_field').addClass('disabled');
			}
			else {
				_.set(model, 'locked_elements', false);
				this.getUI('payment_field').removeClass('disabled');
			}
		}

		_.set(model, name, val);

		this.model.set(model, { silent: true });
	}

	validateForm() {
		const
			errors = [],
			{ card_number, card_expiry, card_cvv, name } = this.card,
			{ terms, adult } = this.model.toJSON();

		if (!terms) {
			errors.push({ text: 'Terms and Conditions field is required!' });
		}

		if (!adult) {
			errors.push({
				text: 'Please confirm you are over' +
				' 18 or have the permission of your parent/guardian!'
			});
		}

		if (!name) {
			errors.push({
				text: 'Cardholder\'s name field is required!'
			});
		}

		if (card_number._invalid) {
			errors.push({
				text: 'Please enter correct card number!'
			});
		}

		if (card_expiry._invalid) {
			errors.push({
				text: 'Please enter correct expiry date!'
			});
		}

		if (card_cvv._invalid) {
			errors.push({
				text: 'Please enter correct cvc code!'
			});
		}

		return errors;
	}

	validateCodeForm() {
		const
			errors           = [],
			code_coach   = this.model.get('code_coach'),
			{ terms, adult } = this.model.toJSON();

		if (!terms) {
			errors.push({ text: 'Terms and Conditions field is required!' });
		}

		if (!adult) {
			errors.push({
				text: 'Please confirm you are over 18 or' +
					' have the permission of your parent/guardian!'
			});
		}

		if ( !code_coach ) {
			errors.push( {
				text: 'Please enter unique Coach Code'
			} );
		}

		return errors;
	}

	onSubmit(event) {
		event.preventDefault();

		const code_coach = this.model.get('code_coach');

		if (code_coach) {
			this.codeOnSubmit(event);
			return this;
		}

		const errors = this.validateForm();

		if (_.size(errors)) {
			event.stopPropagation();

			ErrorsModal.show(errors);

			return this;
		}

		this.trigger('form:submit', this.card);
	}

	codeOnSubmit(event) {
		event.preventDefault();

		const
			code_coach = this.model.get('code_coach'),
			errors = this.validateCodeForm();

		if (_.size(errors)) {
			event.stopPropagation();

			ErrorsModal.show(errors);

			return this;
		}

		this.trigger('form:code:submit', code_coach);
	}

	triggerCancelSubscription(event) {
		event.preventDefault();

		this.trigger('form:cancel:subscription:submit');
	}

	switchToTable() {
		this.template = tpl_table;

		this.model.set({ message: '' });
	}

	switchToForm() {
		this.template = tpl_form;

		this.model.set({
			name: '',
			code_coach: '',
			card_number: [],
			number: '',
			exp_month: '',
			exp_year: '',
			cvc: '',
			terms: false,
			adult: false,
			locked_elements: false,
		});
	}

	onCardKeyUp({ target, keyCode }) {
		const
			{ nextElementSibling, previousElementSibling, value } = target,
			is_valid_value = target.checkValidity(),
			is_backspace = keyCode === 8,
			value_size = _.size(value);

		if (!is_valid_value) {
			return this;
		}

		if (value_size === 4 && nextElementSibling) {
			nextElementSibling.focus();
		}

		if (value_size === 0 && previousElementSibling && is_backspace) {
			previousElementSibling.focus();
		}
	}

	renderForm() {
		// console.log(this.getUI('card_element').is(':empty'));
		if (!this.getUI('card_number').length) {
			return this;
		}
		const elements = window.stripe.elements();
		const card_number = elements.create('cardNumber', { ...style, placeholder: '' });
		card_number.mount('.js-card-number');

		const card_expiry = elements.create('cardExpiry', { ...style, placeholder: 'MM/YY' });
		card_expiry.mount('.js-card-expiry');

		const card_cvv = elements.create('cardCvc', { ...style, placeholder: 'CVC' });

		card_cvv.mount('.js-card-cvv');

		this.model.set({
			card_number,
			card_expiry,
			card_cvv
		}, { silent: true })
	}
}